import { render, staticRenderFns } from "./productList.vue?vue&type=template&id=6f2828da&scoped=true"
import script from "./productList.vue?vue&type=script&lang=js"
export * from "./productList.vue?vue&type=script&lang=js"
import style0 from "./productList.vue?vue&type=style&index=0&id=6f2828da&prod&lang=scss&scoped=true"
import style1 from "./productList.vue?vue&type=style&index=1&id=6f2828da&prod&lang=scss"
import style2 from "./productList.vue?vue&type=style&index=2&id=6f2828da&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2828da",
  null
  
)

export default component.exports